/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
var E;!function(E){E[E.FEATURE=1]="FEATURE",E[E.SELF=2]="SELF",E[E.ALL=3]="ALL"}(E||(E={}));export{E as SnappingDomain};
